import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Table, Form, Modal } from 'react-bootstrap';
import $ from 'jquery';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import * as Common from '../Common';
import Dialog from '../Dialog';
import '../../mcss/common.css';

import TransactionComment from './TransactionComment';

function ApiMaker(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [rightApiMaker, setRightApiMaker] = useState([]);

    const [reqData, setReqData] = useState([]);
    const [docListData, setDocListData] = useState([]);
    const [coverListData, setCoverListData] = useState([]);

    const [reqCoverValue, setReqCoverValue] = useState("");
    const [reqCoverTotValue, setReqCoverTotValue] = useState(0);

    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);

    const [logListData, setLogListData] = useState([]);

    const [remark, setRemark] = useState("");

    const [todayDate, setTodayDate] = useState("");

    const [readyToPush, setReadyToPush] = useState(false);

    const [bankApiCalled, setBankApiCalled] = useState(1);
    const [bankRefNo, setBankRefNo] = useState("");
    const [ad2Ref, setAd2Ref] = useState("");
    const [reqApiMaker, setReqApiMaker] = useState(0);
    const [reqApiChecker, setReqApiChecker] = useState(0);
    const [reqValueDate, setReqValueDate] = useState(new Date());

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'BANKAPIMAKER'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {

                    if (sessionStorage.IdfcApiValueDate === undefined) {
                        sessionStorage.IdfcApiValueDate = new Date();
                    }
                    setReqValueDate(new Date(sessionStorage.IdfcApiValueDate));


                    setRightApiMaker(resp);
                    Common.callApi(Common.apiBankFile, [sid, 'bankfiledetail', props.srno], function (result2) {
                        let resp2 = JSON.parse(result2);
                        setReqData(resp2[0]);
                        let resp3 = resp2[0];
                        setBankRefNo(resp3.req_bankrefno);
                        setAd2Ref(resp3.req_ad2ref);
                        setBankApiCalled(resp3.req_bankfilegenrated);
                        setReqApiMaker(resp3.req_apimaker);
                        setReqApiChecker(resp3.req_apichecker);
                    });
                    Common.callApi(Common.apiInProgress, [sid, 'detail', props.srno], function (result1) {
                        let resp1 = JSON.parse(result1);
                        setDocListData(resp1.req_documentdetail);
                        setLogListData(resp1.req_activitylog);
                        let today = new Date();
                        setTodayDate(today.getDate() + "-" + parseInt(today.getMonth() + 1) + "-" + today.getFullYear());
                    });
                    Common.callApi(Common.apiCover, [sid, 'listjson', props.srno], function (result) {
                        var arr = JSON.parse(result)
                        setCoverListData(arr);
                        var tvalue = 0;
                        if (arr.length > 0) {

                            for (var i = 0; i < arr.length; ++i) {
                                tvalue = tvalue * 1 + arr[i]["cvalue"] * 1;
                            }
                            setReqCoverTotValue((tvalue).toFixed(2));
                        }
                        if ((resp.req_quantity * 1 - tvalue * 1) > 0) {
                            setReqCoverValue((resp.req_quantity * 1 - tvalue * 1).toFixed(2));
                        }
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function btnBackClick() {
        props.callInProgress();
    }

    function btnDocumentView(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }

    function btnAddComment() {
        var object1 = {
            srno: props.srno,
            cmnt: remark
        }
        Common.callApi(Common.apiPaymentApprove, [sid, 'addcomment', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            if (resp.err === "") {
                setRemark("");
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.err);
                setMsgBox(true);
            }
            setRefreshCounter(refreshCounter + 1);
        });
    }

    function handleReadyToPush() {
        setReadyToPush(!readyToPush);
    }

    function btnSendToApi() {
        $('.loader').show();
        var msg = [], i = 0;
        //console.log(Common.dateDMY_Minus(reqValueDate)); i++;
        setBankApiCalled(1);
        if (!readyToPush) {
            msg[i++] = "Please click confirmation.";
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);

        }
        if (i == 0) {
            var obj = {
                srno: props.srno,
                valuedate: Common.dateDMY_Minus(reqValueDate)
            }
            Common.callApi(Common.apiIdfcRemit, [sid, 'sendtobank', JSON.stringify(obj)], function (result) {
                // {"CustomerReference":"ZENITHKO18122023000044","Error":"","digirefNumber":"AD2TT23121800068","status":"Success"}
                let resp1 = JSON.parse(result);
                let resp = JSON.parse(result);
                console.log(result);
                if (resp1.Error === undefined) {
                    resp = resp1[0];
                } else {
                    resp = resp1;
                }
                var msg1 = [], j = 0;
                if (resp.Error === "") {
                    msg1[j++] = "Transaction Processing " + resp.status;
                    msg1[j++] = "IDFC Reference " + resp.CustomerReference;
                    msg1[j++] = "AD2 RefNumber " + resp.digirefNumber;
                    setBankApiCalled(1);
                    setReqApiMaker(1);
                    setReqApiChecker(1);
                    setBankRefNo(resp.CustomerReference);
                    setAd2Ref(resp.digirefNumber);
                } else {
                    msg1[j++] = "" + resp.Error;
                    setBankApiCalled(0);
                }
                $('.loader').hide();
                setMsgText(Common.buildMessageFromArray(msg1));
                setMsgBox(true);
            });
        } else {
            console.log("Not calling api");
            $('.loader').hide();
        }
    }

    function btnCheckStatus() {
        $('.loader').show();
        var obj = {
            srno: props.srno,
            corprefno: bankRefNo
        }
        Common.callApi(Common.apiIdfcRemit, [sid, 'checkstatus', JSON.stringify(obj)], function (result) {
            //let resp = JSON.parse(result);
            $('.loader').hide();
            alert(result);
        });
    }

    function btnDownSwift() {
        $('.loader').show();
        var obj = {
            srno: props.srno,
            corprefno: bankRefNo,
            fetchtype: "Swift"
        }
        Common.callApi(Common.apiIdfcRemit, [sid, 'getswiftdebit', JSON.stringify(obj)], function (result) {
            //let resp = JSON.parse(result);
            $('.loader').hide();
            alert(result);
        });
    }

    function btnDownDebit() {
        $('.loader').show();
        var obj = {
            srno: props.srno,
            corprefno: bankRefNo,
            fetchtype: "Debit"
        }
        Common.callApi(Common.apiIdfcRemit, [sid, 'getswiftdebit', JSON.stringify(obj)], function (result) {
            //let resp = JSON.parse(result);
            $('.loader').hide();
            alert(result);
        });
    }

    function changeValueDate(v) {
        setReqValueDate(v)
        sessionStorage.IdfcApiValueDate = v;

    }

        const getMimeType = (ext) => {
        switch (ext.toLowerCase()) {
            case "pdf":
                return "application/pdf";
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };

    const openDocument = (resp) => {
        setDocumentToView(resp.url_path);
        setDocumentTypeToView(getMimeType(resp.doc_ext));
        setDocumentDescToView(resp.docm_desc);
        setDocumentNameToView(resp.doc_aws_path);
        setShowDocument(true);
    };


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>Bank Api</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    {
                        bankApiCalled * 1 === 0 && rightApiMaker.add === "1" ? <>
                            <Row>
                                <Col>
                                    <Form.Group >
                                        <Form.Label>Value Date<span className="mandatory">*</span></Form.Label>
                                        <DatePicker className="form-control"
                                            selected={reqValueDate}
                                            onChange={(date) => changeValueDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>
                                <Col></Col><Col></Col><Col></Col>
                            </Row>
                            <Row>
                                <Col>
                                    <input
                                        type="checkbox"
                                        checked={readyToPush}
                                        onChange={handleReadyToPush}
                                    />
                                    &nbsp;I have checked all the details. Details are ok to process.&nbsp;
                                    {
                                        readyToPush ? <>
                                            <Button variant="outline-danger" size="sm" onClick={(e) => btnSendToApi()} >Push To Bank</Button>&nbsp;
                                        </> : null
                                    }

                                </Col>
                            </Row>
                        </> : <>
                            <Row>
                                <Col>
                                    Bank Ref No <b>{bankRefNo}</b>
                                </Col>
                                <Col>
                                    AD2 Ref No <b>{ad2Ref}</b>
                                </Col>
                                <Col>

                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </>
                    }
                    {
                        bankApiCalled * 1 === 1 && reqApiChecker * 1 === 1 && rightApiMaker.add === "1" && sessionStorage.userSrno === "1" ? <>
                            <Row>
                                <Col>&nbsp;</Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant="outline-success" size="sm" onClick={(e) => btnCheckStatus()} >Check Status</Button>&nbsp;&nbsp;
                                    <Button variant="outline-success" size="sm" onClick={(e) => btnDownSwift()} >Swift</Button>&nbsp;&nbsp;
                                    <Button variant="outline-success" size="sm" onClick={(e) => btnDownDebit()} >Debit</Button>
                                </Col>
                            </Row>
                        </> : null
                    }
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>Transaction</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Date
                        </Col>
                        <Col>
                            Mode
                        </Col>
                        <Col>
                            InstrumentNo
                        </Col>
                        <Col>
                            Currency
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{todayDate}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_productcode}</b>
                        </Col>
                        <Col>
                            <b></b>{/*InstrumentNo*/}
                        </Col>
                        <Col>
                            <b>{reqData.req_isd}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>

                        <Col>
                            Amount
                        </Col>
                        <Col>
                            Rate
                        </Col>
                        <Col>
                            INR
                        </Col>
                        <Col>
                            DealID
                        </Col>
                    </Row>
                    <Row>

                        <Col>
                            <b>{reqData.req_covervalue}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_dealrate}</b>
                        </Col>
                        <Col>
                            <b>{(1 * reqData.req_quantity * reqData.req_issuercover).toFixed(2)}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_dealno}</b>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>Remitter</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            RemitterType
                        </Col>
                        <Col>
                            RemitterFName
                        </Col>
                        <Col>
                            RemitterMName
                        </Col>
                        <Col>
                            RemitterLName
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.req_remittertype == "I" ? "INDIVIDUAL" : "CORPORATE"}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_remitternamefirst}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_remitternamemiddle}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_remitternamelast}</b>
                        </Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            RemitterPAN
                        </Col>
                        <Col>
                            RemitterCountry
                        </Col>
                        <Col>
                            RemitterCity
                        </Col>
                        <Col>
                            RemitterAddress
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.req_pan}</b>
                        </Col>
                        <Col>
                            <b>INDIA</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_remittercity}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_remitteraddress}</b>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>BeneficiaryDetails</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            BeneficiaryType
                        </Col>
                        <Col>
                            BeneficiaryFName
                        </Col>
                        <Col>
                            BeneficiaryMName
                        </Col>
                        <Col>
                            BeneficiaryLName
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.req_benetype == "I" ? "INDIVIDUAL" : "ENTITY"}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_benenamefirst}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_benenamemiddle}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_benenamelast}</b>
                        </Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            BeneCountry
                        </Col>
                        <Col>
                            BeneCity
                        </Col>

                        <Col xs={6}>
                            BeneficiaryAddress
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.bc_cnt_name}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_benecity}</b>
                        </Col>

                        <Col xs={6}>
                            <b>{reqData.req_beneadd}</b>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>Bank Details</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            BeneBankName
                        </Col>
                        <Col>
                            BeneficiaryAcNo
                        </Col>
                        <Col>
                            BeneBankCountry
                        </Col>
                        <Col>
                            BeneBankAddress
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.req_benebank}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_benebankacct}</b>
                        </Col>
                        <Col>
                            <b>{reqData.bbc_cnt_name}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_benebankadd}</b>
                        </Col>

                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            BeneBankSWIFTDetails
                        </Col>
                        <Col>
                            BeneBankSORTCode
                        </Col>
                        <Col>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.req_beneswiftcode}</b>
                        </Col>
                        <Col>
                            <b>{(reqData.req_isd === "AUD" ? reqData.req_benebsbno : ((reqData.req_isd === "USD" && reqData.req_beneswiftcode === "") ? reqData.req_beneroutingno : ""))}</b>
                            {/* reqData.req_benesortcode  */}
                        </Col>
                        <Col>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>IntermBankDetails</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            IntermBankName
                        </Col>
                        <Col>
                            Intermbankcountry
                        </Col>
                        <Col>
                            IntermBICCode
                        </Col>
                        <Col>
                            Intermsortcode
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.req_corresbankname}</b>
                        </Col>
                        <Col>
                            <b>{reqData.cbc_cnt_name}</b>
                        </Col>
                        <Col>
                            <b>{reqData.req_corresbankacctno}</b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>IntermAddress</Col>
                        <Col></Col>
                        <Col></Col>
                        <Col></Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.req_corresbankadd}</b>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>OtherDetails</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Purposecode
                        </Col>
                        <Col>
                            EducationalDetails
                        </Col>
                        <Col>
                            CorrespondentBankCharges
                        </Col>
                        <Col>
                            FBCharges
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b>{reqData.purpose_idfccode}</b>
                        </Col>
                        <Col>
                            <b>
                                {reqData.req_otherdetailmerged}
                            </b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b>{reqData.req_nostrotype}</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            MerchantUserIdentity
                        </Col>
                        <Col>
                            AdditionalField1
                        </Col>
                        <Col>
                            AdditionalField2
                        </Col>
                        <Col>
                            AdditionalField3
                        </Col>
                    </Row>
                    <Row>
                        <Col><b>Individual</b></Col>
                        <Col><b>{reqData.req_isd == 'AED' && reqData.req_benecountry == "36" ? "//BENEFRES/AE//EDU///EDUCATION" : ""}</b></Col>
                        <Col><b></b></Col>
                        <Col></Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            AdditionalField4
                        </Col>
                        <Col>
                            AdditionalField5
                        </Col>
                        <Col>
                            AdditionalField6
                        </Col>
                        <Col>
                            AdditionalField7
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b>{reqData.req_refno}</b>
                        </Col>
                        <Col>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            AdditionalField8
                        </Col>
                        <Col>
                            AdditionalField9
                        </Col>
                        <Col>
                            AdditionalField10
                        </Col>
                        <Col>
                            AdditionalField11
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            AdditionalField12
                        </Col>
                        <Col>
                            AdditionalField13
                        </Col>
                        <Col>
                            AdditionalField14
                        </Col>
                        <Col>
                            AdditionalField15
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                        <Col>
                            <b></b>
                        </Col>
                    </Row>


                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>Cover Details</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={
                                (reqCoverTotValue * 1 - reqData.req_quantity * 1) > 0 ? "divDanger" : "divNormal"
                            }
                            >
                                <b>Total Cover : {reqCoverTotValue}</b>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>

                                        <td className='divHide'></td>
                                        <td>Cover Bank</td>
                                        <td>Cover Quantity</td>
                                        <td>Cover Rate</td>
                                        <td>Deal Number</td>
                                        <td>Expiry Date</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {coverListData.map((res) =>
                                        <tr key={res.srno}>

                                            <td className='divHide'>{res.srno}</td>
                                            <td>{res.bank + ' : ' + res.banknm}</td>
                                            <td>{res.cvalue}</td>
                                            <td>{res.rate}</td>
                                            <td>{res.deal}</td>
                                            <td>{(res.vdate).split('-').reverse().join('/')}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>Documents</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                         <td>Upload Timestamp</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.srno}>
                                            <td>{res.doc_id + ' : ' + res.docm_desc}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_aws == 1 ? res.doc_aws_path.slice(10) : res.doc_filename}</td>
                                             <td>{res.doc_uploadedat}</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                {
                                                    ( res.doc_aws != 1 && (res.doc_ext === "pdf" || res.doc_ext === "jpeg" || res.doc_ext === "gif"
                                                    || res.doc_ext === "jpg" || res.doc_ext === "png") ) ? <>
                                                    <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </span>&nbsp;
                                                    </> : null
                                                }

                                                 &nbsp;
                                             
                                                    {(res.doc_aws == 1 &&
                                                        (
                                                            res.doc_ext === "pdf" ||
                                                            res.doc_ext === "jpeg" ||
                                                            res.doc_ext === "gif" ||
                                                            res.doc_ext === "jpg" ||
                                                            res.doc_ext === "png" ||
                                                            res.doc_ext === "webp"
                                                        )) && (
                                                            <span
                                                                onClick={() => Common.viewUploadedDocument(res.doc_aws_path, sid,openDocument)}
                                                                className="pointer colorThemeBlue"
                                                            >
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                    )}

                                                    {res.doc_aws == 1 ? (
                                                        <span className="handCursor" onClick={() => Common.downloadUploadedDocument(res.doc_aws_path, sid)}>
                                                            <FontAwesomeIcon icon={faFileDownload} />

                                                        </span>
                                                    ) :
                                                    <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faFileDownload} />
                                                    </span>
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={6}>
                            <Form.Group >
                                <Form.Label>Comment</Form.Label>
                                <Form.Control type="text" placeholder="Comment" maxLength={100}
                                    onChange={(e) => Common.validateAlpNumValue(e.target.value, setRemark)}
                                    value={remark} autoComplete="off" />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group >
                                <Form.Label>&nbsp;</Form.Label><br></br>
                                <Button variant="outline-success" size="sm" onClick={(e) => btnAddComment()} >Add Comment</Button>&nbsp;
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <TransactionComment srno={props.srno} rc={refreshCounter}></TransactionComment>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>Activity Log</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>
                                        <td>Time Stamp</td>
                                        <td>User Name</td>
                                        <td>Remark</td>
                                    </tr>
                                </thead>
                                <tbody>

                                    {logListData.map((res) =>
                                        <tr key={res.reqlog_rndnum}>
                                            <td>{res.reqlog_logtime}</td>
                                            <td>{res.um_username}</td>
                                            <td>{res.reqlog_rmk}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                    {
                        /*
                        type="image/png" type="application/pdf"
                        width="100%" height="100%"
                        
                        <object data={documentToView} type={documentTypeToView} class="internal">
    
                        </object>
                        */
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
export default ApiMaker;